import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { UnitsTab } from '@/components/registry/UnitsTab';
import { PeopleTab } from '@/components/registry/PeopleTab';
import { DocumentsTab } from '@/components/registry/DocumentsTab';
import { TreeTab } from '@/components/registry/TreeTab';
import { TimelineTab } from '@/components/registry/TimelineTab';
import AnagraficaFormManager from '@/components/AnagraficaFormManager';
import { PageHeader } from '@/components/PageHeader';

export const Registry = () => {
  const { selectedCondominium, user } = useAuth();
  const [activeTab, setActiveTab] = useState('albero');
  
  // amministratore del condominio scelto (o del sistema)
  const isAdmin = user?.role === 'ADMIN' || user?.is_super_admin || selectedCondominium?.role === 'ADMIN';

  if (!selectedCondominium) {
    return (
      <div className="space-y-8" data-testid="registry-page">
        <PageHeader title="Anagrafica" subtitle="Seleziona un condominio per gestire l'anagrafica" />
      </div>
    );
  }

  return (
    <div className="space-y-8" data-testid="registry-page">
      <PageHeader
        title="Anagrafica"
        subtitle="Gestione unità, proprietari e documenti"
        actions={isAdmin ? (
          <AnagraficaFormManager
            condominiumId={selectedCondominium.condominium.id}
            condominiumName={selectedCondominium.condominium.name}
          />
        ) : undefined}
      />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList>
          <TabsTrigger value="albero" data-testid="albero-tab">Albero</TabsTrigger>
          <TabsTrigger value="units" data-testid="units-tab">Unità</TabsTrigger>
          <TabsTrigger value="people" data-testid="people-tab">Soggetti</TabsTrigger>
          <TabsTrigger value="documents" data-testid="documents-tab">Documenti</TabsTrigger>
          <TabsTrigger value="confronto" data-testid="confronto-tab">Confronto anni</TabsTrigger>
        </TabsList>

        <TabsContent value="albero">
          <TreeTab condominiumId={selectedCondominium.condominium.id} isAdmin={isAdmin} />
        </TabsContent>

        <TabsContent value="units">
          <UnitsTab condominiumId={selectedCondominium.condominium.id} />
        </TabsContent>

        <TabsContent value="people">
          <PeopleTab condominiumId={selectedCondominium.condominium.id} />
        </TabsContent>

        <TabsContent value="documents">
          <DocumentsTab condominiumId={selectedCondominium.condominium.id} />
        </TabsContent>

        <TabsContent value="confronto">
          <TimelineTab condominiumId={selectedCondominium.condominium.id} />
        </TabsContent>
      </Tabs>
    </div>
  );
};